import { Component, Input } from '@angular/core';
import { EVENTS_CONFIG } from '@app-core/constants/constants';
@Component({
  selector: 'app-coaching-session-accolades',
  templateUrl: './coaching-session-accolades.component.html',
  styleUrls: ['./coaching-session-accolades.component.scss'],
})
export class CoachingSessionAccoladesComponent {
  @Input() public coachingDetails;
  @Input() public loader: boolean = false;

  public eventsConfig = EVENTS_CONFIG;

  constructor() {}
}
